module.exports = __webpack_public_path__ + "static/media/icon_recycle_shop.8bec85f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_recycle_shop.svg
// module id = 1846
// module chunks = 0